
// document.addEventListener("DOMContentLoaded", function(event) {
//   if (!jQuery(Yotpo.getStars()).find("span:not('.yotpo-icon-empty-star')").length) jQuery(Yotpo.widgets.main.selector).hide();
//   console.log("DOM loaded and ready!");
// });

document.addEventListener('rebuy:cart.change', function(event){
	const itemsLength = window.Rebuy.Cart.cart.item_count;
	jQuery(document).find('.cart-item-count-header--quantity').html(itemsLength);
});

$(document).ready(function () {
    console.log(221);
    function adjustMinWidth() {
      if ($(window).width() > 992) {
        $('.dropdown-menu').each(function () {
            var maxWidth = 0;

            // Iterate through each link inside the current .dropdown-menu
            $(this).find('.dropdown-submenu__link').each(function () {
                // Create a temporary element to measure text width accurately
                var $temp = $('<span>').text($(this).text()).css({
                    'font-family': $(this).css('font-family'),
                    'font-size': $(this).css('font-size'),
                    'visibility': 'hidden',
                    'position': 'absolute'
                }).appendTo('body');

                // Get the width of the text
                var textWidth = $temp.width();

                // Update maxWidth if the current link's width is greater
                if (textWidth > maxWidth) {
                    maxWidth = textWidth;
                }

                // Remove the temporary element after measurement
                $temp.remove();
            });

            // Set the minimum width of the current .dropdown-menu based on the widest link
            $(this).css('min-width', (maxWidth + 130) + 'px'); // Adjust padding value as necessary
        });
      }
    }

    // Run the function on document ready
    adjustMinWidth();


    function instantBuy(){
       var $ = jQuery;
  
     var formParams = $('form.cart').serialize();
       $.ajax({
        url: "/cart/add",
        type: "post",
        data: formParams,
        success: function(){ 
          console.log('test12');
         window.location.href = "/checkout";
        },
        error: function(){
        }
       })
  }
});




// var targetProductId = 6562280210617;

// $(document).on('submit', 'form[action="/cart/add"]', function(e) {
//     e.preventDefault();

//     var formData = $(this).serialize();
//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: formData,
//         dataType: 'json',
//         success: function(response) {
//           console.log(response.id);
//             if (response.id == 6562280210617) {
//                 console.log('test21');
//                 location.reload();
//             } 
//         },
//         error: function() {
//         }
//     });
// });


// Wait for the window's 'load' event, which ensures all elements and scripts are present.
window.addEventListener('load', function() {
  
  // Find the script tag for the Facebook JavaScript SDK. 
  // This script loads connect.facebook.net/en_US/fbevents.js and often has the ID 'facebook-jssdk'.
  var fbScript = document.getElementById('facebook-jssdk');
  
  // Also, search for the script based on its source (URL).
  if (!fbScript) {
    // Find all script tags
    var scripts = document.getElementsByTagName('script');
    
    for (var i = 0; i < scripts.length; i++) {
      // Look for scripts where the source includes 'fbevents.js'
      if (scripts[i].src && scripts[i].src.includes('fbevents.js')) {
        fbScript = scripts[i];
        break; // Stop searching once found
      }
    }
  }

  // Check if the script was found and if it doesn't already have 'defer' or 'async'
  if (fbScript && !fbScript.hasAttribute('defer') && !fbScript.hasAttribute('async')) {
    
    // Dynamically add the 'defer' attribute
    fbScript.setAttribute('defer', '');
    
    console.log('fbevents.js script deferred successfully.');
  }
});



